import { Component } from '@angular/core';
import { IndexView } from '@common/views';
import { Survey } from '@models/performance/survey.model';
import { AuthService } from '@app/services';
import { Employee } from '@models/employee/employee.model';
import { ActivatedRoute } from '@angular/router';
import { Status } from '@performance/enums/status.enum';
import { SurveyIndexTable } from '@employees/services/tables/survey-table/survey-index.table';

@Component({
    templateUrl: './survey-index.template.html',
    styleUrls: ['./survey-index.style.scss'],
})
export class SurveyIndexView extends IndexView {
    isLoading = false;
    viewPermission = Survey.permission.view;
    createPermission = Survey.permission.edit;
    Status = Status;
    employee: Employee;
    table: SurveyIndexTable;

    constructor(
        protected auth: AuthService,
        protected route: ActivatedRoute
    ) {
        super();

        this.employee = this.route.snapshot.data.models.get('employee');
        this.table = new SurveyIndexTable(this.auth, this.employee.id);
        this.table.reload();
    }

    onCreate(): void {
        // Not used
    }
}
